// Import build information from JSON file
// This file is generated by the pipeline during build
import buildInfo from './build-info.json';

export const BUILD_VERSION = buildInfo.version;
export const BUILD_ENV = buildInfo.environment;
